import React from 'react'
import '../../../design/App.css'
import { Layout } from 'antd'
import { observer } from 'mobx-react-lite'
import { footerStyle } from '../../../design/app-style-config'
import { translate } from '../../../cls/TranslationContext'
const { Footer } = Layout

const MainFooter = observer(() => {
	return (
		<Footer style={footerStyle} id="app-footer">
			{translate('single.powered-by')}{' '}
			<a href="https://webackit.com">webackit.com©</a>
		</Footer>
	)
})

export default MainFooter
